import button from './componentsVi/button'
import searchBox from './componentsVi/searchBox'
import grid from './componentsVi/grid'
import alert from './componentsVi/alert'
import dialog from './componentsVi/dialog'
import message from './componentsVi/message'
import route from './componentsVi/route'
import variable from './componentsVi/variable'
import field from './componentsVi/field'
import validator from './componentsVi/validator'
import views from './componentsVi/views'
export default {
  ...message,
  ...button,
  ...searchBox,
  ...grid,
  ...alert,
  ...dialog,
  ...route,
  ...variable,
  ...field,
  ...validator,

  // Views
  ...views,

  // **************************OLD DATA BELOW************************
  // ============================ Config =========================== //
  config: {
    // ============================ Profile =========================== //
    profile: {
      common: {
        // btn
        add: 'Thêm hồ sơ',
        edit: 'Sửa hồ sơ',
        merge: 'Gộp hồ sơ',
        exportExcel: 'Xuất Excel',
        importExcel: 'Nhập từ Excel',
        delete: 'Xóa hồ sơ',
        placeholder: 'Nhập thông tin',
        confirmBtnText: 'OK',

        cancel: 'Hủy',
        agree: 'Đồng ý',
        update: 'Cập nhật',
        create: 'Tạo mới',
        close: 'Đóng',
        excelTemplateDownload: 'Tải mẫu',
        excelUploadButton: 'Chọn tệp tin',

        //
        assignAccount: 'Gán tài khoản',
        note: 'Ghi chú',
        addNote: 'Thêm ghi chú',
        editNote: 'Sửa ghi chú',
        deleteNote: 'Xóa ghi chú'
      },
      searchBox: {
        hideFilter: 'Ẩn bộ lọc',
        showFilter: 'Hiện bộ lọc',
        refreshFilter: 'Xóa bộ lọc',
        search: 'Tìm kiếm',

        // company
        info: 'Thông tin',
        profileType: 'Loại hồ sơ',
        source: 'Nguồn',
        businessManName: 'Nhân viên kinh doanh theo chuỗi',

        // customer/traveller
        travellerInfo: 'Thông tin khách',
        nationality: 'Quốc tịch',
        address: 'Địa chỉ',
        idCard: 'Hộ chiếu/Thẻ căn cước',
        email: 'Email',
        phoneNumber: 'Số điện thoại'

        // company with invoice
      },
      // selectWithSearchTable
      select: {
        profileType: 'Loại hồ sơ',
        businessManCode: 'Mã nhân viên',
        businessManName: 'Tên nhân viên',
        nationalityCode: 'Mã quốc tịch',
        nationalityName: 'Tên quốc tịch',
        nationCode: 'Mã quốc gia',
        nationName: 'Tên quốc gia',
        marketSegCode: 'Mã phân khúc thị trường',
        sourceCode: 'Mã nguồn',
        customerLevelCode: 'Mã hạng khách',
        description: 'Mô tả'
      },
      field: {
        profileCode: 'Mã hồ sơ',
        name: 'Tên công ty, đại lý du lịch',
        invoiceAgentName: 'Tên công ty trên hóa đơn',
        companyName: 'Tên công ty',
        marketSegName: 'Phân khúc thị trường',
        email: 'Email',
        phone: 'Số điện thoại',
        phone1: 'Số điện thoại 1',
        phone2: 'Số điện thoại 2',
        address1: 'Địa chỉ 1',
        address2: 'Địa chỉ 2',
        bankName: 'Tên ngân hàng',
        bankNumber: 'Số tài khoản',
        businessManName: 'Nhân viên kinh doanh theo chuỗi',
        profileType: 'Loại hồ sơ',
        businessCode: 'Mã doanh nghiệp',
        taxCode: 'Mã số thuế',
        nation: 'Quốc gia',
        nationality: 'Quốc tịch',
        state: 'Tiểu bang',
        city: 'Thành phố',
        zipCode: 'Mã bưu điện',
        repName: 'Người đại diện',
        repEmail: 'Email người đại diện',
        repPhone1: 'SĐT 1 của người đại diện',
        repPhone2: 'SĐT 2 của người đại diện',
        repBirth: 'Ngày sinh của người đại diện',
        repIdCard: 'Thẻ căn cước của người đại diện',
        repIdCardDate: 'Ngày cấp thẻ căn cước của người đại diện',
        repIdCardPlace: 'Nơi cấp thẻ căn cước của người đại diện',
        birth: 'Ngày sinh',
        idCard: 'Hộ chiếu/Thẻ căn cước',
        idCardIssuedDate: 'Ngày cấp',
        idCardIssuedPlace: 'Nơi cấp',
        note: 'Ghi chú',
        contactNote: 'Ghi chú liên hệ',
        marketSeg: 'Phân khúc thị trường',
        businessSeg: 'Mã phân khúc kinh doanh',
        source: 'Nguồn',
        sourceCode: 'Mã nguồn',
        nameMini: 'Tên',
        position: 'Chức vụ',
        hotelId: 'Đơn vị',
        debitAccountName: 'Tài khoản công nợ',
        debitAccountNumber: 'Số tài khoản công nợ',
        mainAccount: 'Tài khoản chính',
        hotelId1: 'ID khách sạn',

        // customer form
        lastName: 'Họ',
        firstName: 'Tên',
        vocative: 'Danh xưng',
        gender: 'Giới tính',
        passport: 'Hộ chiếu',
        address: 'Địa chỉ',
        image: 'Ảnh',
        front_image: 'Mặt trước',
        back_image: 'Mặt sau',
        mGender: 'Nam',
        fGender: 'Nữ',
        greeting: 'Lời chào',
        customerLevel: 'Hạng khách',
        memberId: 'ID thành viên',
        visa: 'Visa',
        visaExpiredDate: 'Ngày hết hạn Visa',
        visaAndExpiredDate: 'Visa/Ngày hết hạn',
        visaPlace: 'Nơi cấp',
        idCardAndIssuedDate: 'Thẻ căn cước/Ngày cấp',
        job: 'Nghề nghiệp',
        idCardPlace: 'Nơi cấp thẻ căn cước',
        other: 'Giấy tờ khác',
        noteType: 'Loại ghi chú',
        noteContent: 'Nội dung'
      },
      title: {
        company: 'HỒ SƠ CÔNG TY, ĐẠI LÝ DU  LỊCH',
        companyForm: 'THÊM HỒ SƠ CÔNG TY, ĐẠI LÝ DU LỊCH',
        companyFormSub1: 'THÔNG TIN CHUNG',
        companyFormSub2: 'DỮ LIỆU THỐNG KÊ (Theo từng khách sạn)',
        companyFormSub3: 'LIÊN HỆ',
        companyFormSub4: 'THÔNG TIN KHÁC',
        companyFormSub5: 'TÀI KHOẢN CÔNG NỢ',
        companyFormSub6: 'NGƯỜI ĐẠI DIỆN',
        assignAccountDialog: 'GÁN TÀI KHOẢN CÔNG NỢ',
        mergeDialog: 'GỘP HỒ SƠ',
        importExcelDialog: 'NHẬP TỪ EXCEL',
        createTravellerForm: 'Thêm hồ sơ khách',
        updateTravellerForm: 'Sửa hồ sơ khách',
        travellerFormSub1: 'THÊM HỒ SƠ...',
        travellerNote: 'GHI CHÚ HỒ SƠ',
        invoiceCom: 'THÊM HỒ SƠ CÔNG TY XUẤT HÓA ĐƠN'
      },
      vxConfirm: {
        alert: 'Vui lòng chọn hồ sơ',
        delete: 'Bạn chắc chắn muốn xoá (các) hồ sơ này?'
      },
      message: {
        idNotFound: 'ID hồ sơ không tồn tại'
      },
      dialog: {
        companyCbLabel: 'Không in giá với những đặt phòng của công ty này',
        unattachListTitle: 'Danh sách tài khoản chưa chọn',
        attachListTitle: 'Danh sách tài khoản đã chọn',
        tab1: 'Thông tin chung',
        tab2: 'Liên hệ',
        tab3: 'Tài khoản công nợ',

        // customer's dialog
        cTab1: 'Thông tin khách',

        // invoice company 's dialog
        iTab1: 'Hồ sơ hóa đơn công ty'
      },
      mergeTable: {
        col1: 'Trường thông tin',
        col2: 'Kết quả',
        coln: 'Hồ sơ',
        chooseAll: 'Chọn tất cả'
      }
    },

    account: {
      assign: {
        title: {
          dialog1: 'GÁN GIAO DỊCH MẶC ĐỊNH CHO KHU KINH DOANH',
          dialog2: 'GÁN GIAO DỊCH TIỀN PHÒNG/BÀN CHO KHU KINH DOANH',
          dialog3: 'GÁN GIAO DỊCH CHO SẢN PHẨM/DỊCH VỤ',
          sub1_1: 'GÁN GIAO DỊCH {txn} CHO KHU KINH DOANH',
          sub2_1: 'GÁN GIAO DỊCH {txn} CHO KHU KINH DOANH',
          sub3_1: 'GÁN GIAO DỊCH {txn} CHO SẢN PHẨM/DỊCH VỤ',
          sub3_2: 'TÌM VÀ CHỌN SẢN PHẨM',
          sub3_3: 'DANH SÁCH SẢN PHẨM',
          sub3_4: 'DANH SÁCH SẢN PHẨM ĐÃ ĐƯỢC CHỌN'
        },
        field: {
          txn: 'Giao dịch',
          subTxn: 'Giao dịch phụ',
          business: 'Khu kinh doanh',
          isShift: 'Theo ca',
          id: 'ID',
          shiftName: 'Tên ca',
          businessDistrictCode: 'Mã khu kinh doanh',
          businessDistrictName: 'Tên khu kinh doanh',
          configTp: 'Loại cấu hình',
          curTxn: 'Giao dịch hiện tại',
          curSubTxn: 'Giao dịch phụ hiện tại',
          menu: 'Menu',
          menuName: 'Tên menu',
          category: 'Danh mục',
          productCodeOrName: 'Mã/Tên sản phẩm',
          productCode: 'Mã sản phẩm',
          productName: 'Tên sản phẩm',
          shift: 'Ca (Mã giao dịch)'
        },
        btn: {
          btn1: 'Gán giao dịch mặc định cho khu kinh doanh',
          btn2: 'Giao dịch tiền phòng/bàn cho khu kinh doanh',
          btn3: 'Gán giao dịch cho sản phẩm/dịch vụ',
          btn4: 'Xóa cấu hình',
          close: 'Đóng',
          submit: 'Chọn'
        },
        msg: {
          businessDistrictMustBeChosen: 'Khu kinh doanh bắt buộc phải chọn',
          assignTheDefaultTransactionToTheBusinessDistrictSuccessfully:
            'Gán giao dịch mặc đinh cho khu kinh doanh thành công!',
          configDelete: 'Bạn chắc chắn muốn xoá cấu hình này?'
        }
      }
    },

    // Currency
    currency: {
      cannotDeleteCurrencyIsUsed: 'Không thể xóa đơn vị tiền tệ này'
    }
  },
  // login
  login: {
    password: 'Mật khẩu',
    confirmPassword: 'Nhập lại mật khẩu',
    defaultErrorMsg: 'Đã có lỗi xảy ra.',
    signIn: 'Đăng nhập',
    saveCre: 'Lưu thông tin đăng nhập',
    fotgotPass: 'Quên mật khẩu?',
    dontHaveAcc: 'Không có tài khoản?',
    accountExpired: 'Tài khoản không thể đăng nhập',
    signUp: 'Đăng ký',
    accountIDDoesNotExist: 'Tài khoản không tồn tại.',
    passwordIsNotCorrect: 'Mật khẩu không chính xác.',
    loginByInitPassword: 'Bạn cần đổi mật khẩu cho lần đầu đăng nhập.',
    overThreeMonthFromLastUpdatePasswordDate: 'Mật khẩu đã hết hạn',
    tooLongWithoutChangingPassword: 'Mật khẩu đã hết hạn',
    loginFailure: 'Đăng nhập thất bại',
    thisAccountIsLocked: 'Tài khoản đã bị khóa',
    accountDoesNotActive: 'Tài khoản chưa được kích hoạt'
  },
  // product
  product: {
    type: 'Loại sản phẩm',
    price: 'Giá sản phẩm',
    code: 'Mã sản phẩm',
    name: 'Tên tiếng Viêt',
    engName: 'Tên tiếng Anh',
    unit: 'Đơn vị chính',
    mustNotBeNull: 'không được để rỗng.',
    mustNotBeBlank: 'không được để rỗng.',
    tooLong: 'quá dài.'
  },
  // code
  code: {
    createCodeSuccessfully: 'Tạo mới mã thành công',
    updateCodeSuccessfully: 'Cập nhật mã thành công',
    deleteCodeSuccessfully: 'Xóa mã thành công'
  }
}
